import { MakeDictionary } from 'SharedDir/utils/helpers';

export enum IssueStepStatus {
  inWork = 'inWork',
  waiting = 'waiting',
  completed = 'completed',
  declined = 'declined',
  declinedByIssuer = 'declinedByIssuer',
}

const StatusStepList = [
  {
    label: 'В работе',
    value: IssueStepStatus.inWork,
  },
  {
    label: 'Ожидание',
    value: IssueStepStatus.waiting,
  },
  {
    label: 'Завершено',
    value: IssueStepStatus.completed,
  },
  {
    label: 'Отклонено',
    value: IssueStepStatus.declined,
  },
  {
    label: 'Отменено заявителем',
    value: IssueStepStatus.declinedByIssuer,
  },
];

export const StepIdCancellationIssuer = -1;

export const StatusStepDict = MakeDictionary(StatusStepList, 'value', 'label');
